import React, { useCallback, useEffect } from 'react';
import { Menu, PopoverOrigin } from '@mui/material';

interface Props {
  anchorEl: HTMLElement | null;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  isOpen: boolean;
  children?: any;
  onClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
}

export const BaseChipMenu: React.FC<Props> = ({
  isOpen,
  anchorEl,
  anchorOrigin,
  transformOrigin,
  onClose,
  children = null,
}) => {
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        // Close the menu when an Enter key is pressed
        onClose(event, 'backdropClick');
      }
    },
    [onClose],
  );

  useEffect(() => {
    document.body.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, handleKeyDown]);

  return (
    <Menu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
        ...anchorOrigin,
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
        ...transformOrigin,
      }}
      sx={{ zIndex: 1600 }}
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxHeight: '30vh',
            maxWidth: 300,
          },
        },
      }}
    >
      {children}
    </Menu>
  );
};
